<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            {{ title }}
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-8">
            <div class="row">
              <div class="col-12">
                <article
                  v-for="post in posts"
                  :key="post.id"
                  class="card mb-3 mb-sm-4"
                >
                  <div class="card-header bg-green text-white">
                    {{ post.title }}
                  </div>
                  <div
                    class="card-body wysiwyg-content"
                    v-html="post.content"
                  />
                  <div class="card-footer">
                    <small class="text-dark"><em>Date/Time: <time>{{ post.date_start }}</time></em></small>
                  </div>
                </article>
                <article
                  v-show="posts.length == 0"
                  class="mb-3 mb-sm-4 p-5 text-center"
                >
                  <i>No Events Scheduled</i>
                </article>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <pagination
                  :data="pagination"
                  @pagination-change-page="setPage"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <search />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Events from '../services/events.js';

export default {
  beforeRouteEnter(to,from,next){
    Events.all(to.query).then(res => {
      next(vm => vm.setEvents(res));
    })
  },
  data () {
    return {
      posts: [],
      pagination: {}
    }
  },
  computed: {
    title () {

      let title = 'Events';

      if (this.$route.query.s) {
        title = 'Events Search: ' + this.$route.query.s;
      }

      if (this.$route.query.page > 1) {
        title = title + ' - Page ' + this.$route.query.page;
      }

      return title;
    }
  },
  watch: {
    '$route.query.s': function (s) {
      this.fetchPosts();
    },
    '$route.query.page': function (s) {
      this.fetchPosts();
    },
  },
  methods: {
    fetchPosts () {    
      Events.all(this.$route.query).then(res => {
        this.setEvents(res);
        window.scrollTo(0,0);
      });
    },
    setEvents(res){
      this.posts = res.data;
      this.pagination = res;
    },
    setPage(page = 1) {
      this.$router.push({
        query: { ...this.$route.query, page: page }
      });
    },
  }
}
</script>
